import store from '@/store';
import {
  subCompanyList,
  userDevice
} from '@/api/api';

import { company } from '@/api/system/user/api';
import { getPage, setPage, removePage } from '@/utils/page';
import { getSearch, setSearch, removeSearch } from '@/utils/search';

// 基地
export const companyMixin = {
  data() {
    return {
      userType: store.state.user.userType, // 用户类型
      companyList: [], // 基地列表
      companyNames: [] // 基地名称列表
    };
  },
  created() {
    this.getCompanyList();
  },
  methods: {
    // 获取基地名称
    getCompanyName(id) {
      let name = '';
      for (const item of this.companyNames) {
        if (item.id === id) {
          name = item.name;
          break;
        }
      }
      return name;
    },
    // 递归展开
    flatter(arr) {
      const res = [];
      arr.forEach(item => {
        res.push(item);
        if (Array.isArray(item.childs)) {
          res.push(...this.flatter(item.childs));
        }
      });
      return res;
    },
    // 获取基地列表
    async getCompanyList() {
      const { code, data } = await company();
      if (code === 0) {
        this.companyList = data;
        this.companyNames = this.flatter(data);
      }
    }
  }
};

// 子基地
export const subCompanyMixin = {
  data() {
    return {
      sSBaseId: store.state.user.sSBaseId, // 基地ID
      subCompanyList: [] // 子基地
    };
  },
  created() {
    if (store.state.user.userType === 10) { // 平台用户
      this.getSubCompanyList();
    }
  },
  methods: {
    // 子基地选中值发生变化时触发
    handleChangeSubCompany() {
      this.form.deviceId = '';
      this.deviceList = [];
      this.getDevice();
    },
    // 获取子基地列表
    async getSubCompanyList() {
      const { code, data } = await subCompanyList({
        sSBaseId: this.sSBaseId
      });
      if (code === 0) {
        this.subCompanyList = data;
      }
    }
  }
};

// 用户装置
export const deviceMixin = {
  data() {
    return {
      isGetData: true, // 是否是获取列表数据
      deviceList: [] // 装置
    };
  },
  created() {
    this.getDevice();
  },
  methods: {
    async getDevice() {
      const { code, data } = await userDevice({
        id: store.state.user.id
      });
      if (code === 0) {
        this.deviceList = data;
        if (data.length) {
          if (this.form && !this.form.deviceId) {
            this.form.deviceId = data[0].id;
          }
          if (this.isGetPostData) { // 岗位
            this.getPostList();
          } else if (this.isGetPositionData) { // 功能位置
            this.getPositionList();
          } else if (this.isGetData) { // 列表
            this.getList();
          }
        } else {
          this.loading && (this.loading = false);
        }
      }
    }
  }
};

// 查询
export const queryMixin = {
  data() {
    return {
      loading: true, // 是否加载中
      list: [], // 数据
      currentPage: 1, // 当前页
      pageSize: 15, // 每页个数
      total: 0 // 总条数
    };
  },
  methods: {
    // 查询
    handleQuery(isReload) {
      this.loading = true;
      if (typeof isReload === 'boolean' && isReload) {
        const currentPage = Math.ceil((this.total - 1) / this.pageSize);
        this.currentPage = this.currentPage > currentPage && currentPage > 0 ? currentPage : this.currentPage;
      } else {
        this.currentPage = 1;
      }
      this.updateSession();
      this.getList();
    }
  }
};

// 分页和查询信息存储、获取、移除
export const storeMixin = {
  created() {
    const pager = getPage();
    this.search = getSearch();
    if (pager) {
      this.currentPage = +pager.page;
      this.pageSize = +pager.limit;
    }
    if (this.search) {
      this.form = this.search;
    }
  },
  // 导航离开该组件的对应路由时调用
  beforeRouteLeave(to, from, next) {
    removePage();
    removeSearch();
    next();
  },
  methods: {
    // 更新会话存储
    updateSession() {
      const pager = getPage();
      if (this.currentPage && pager) {
        pager.page = 1;
        setPage(pager);
      }
      setSearch(this.form);
    }
  }
};

// 提交保存
const submitMixin = {
  data() {
    return {
      btnLoading: false, // 是否提交中状态
      visible: false // 是否显示新增或编辑 Dialog
    };
  },
  methods: {
    // 提交保存
    handleSave() {
      this.$refs.CustomAdd.handleSave();
    },
    // 关闭新增或编辑 Dialog
    handleClose() {
      this.visible = false;
      this.getList();
    }
  }
};

// 新增、编辑（编辑请求接口获取数据）
export const addMixin = {
  mixins: [
    submitMixin
  ],
  data() {
    return {
      id: '' // 编辑时的ID
    };
  },
  methods: {
    // 新增
    handleAdd() {
      this.id = '';
      this.btnLoading = false;
      this.visible = true;
    },
    // 编辑
    handleEdit(id) {
      this.id = id;
      this.btnLoading = false;
      this.visible = true;
    }
  }
};

// 新增、编辑（编辑不请求接口获取数据）
export const addDataMixin = {
  mixins: [
    submitMixin
  ],
  data() {
    return {
      data: {} // 编辑时的数据
    };
  },
  methods: {
    // 新增
    handleAdd() {
      this.data = {};
      this.btnLoading = false;
      this.visible = true;
    },
    // 编辑
    handleEdit(data) {
      this.data = Object.assign({}, data);
      this.btnLoading = false;
      this.visible = true;
    }
  }
};

// 返回
export const backMixin = {
  methods: {
    handleBack(event) {
      // 返回是否需要重新加载数据
      this.$route.meta.isReloadData = typeof event === 'boolean' ? event : false;
      this.$router.go(-1);
    }
  }
};

// 只读权限
export const readOnlyPermissionMixin = {
  data() {
    return {
      readOnly: [] // 只读权限
    };
  },
  computed: {
    // 只读
    readOnlyPermission() {
      return this.checkReadOnlyPermission(this.readOnly);
    },
    // 不是只读
    notReadOnlyPermission() {
      return !this.readOnlyPermission;
    }
  },
  watch: {
    // 监听router变化
    $route: {
      handler(to) {
        this.readOnly = [];
        to.matched.forEach(item => {
          if (item.meta && item.meta.readOnly) {
            this.readOnly.push(item.meta.readOnly);
          }
        });
      },
      immediate: true
    }
  }
};

// 删除
export const deleteMixin = {
  methods: {
    // 删除
    handleDelete(id) {
      this.$confirm('确定删除吗?', '提示', {
        type: 'warning'
      }).then(async() => {
        const { code, message } = await this.deleteRow(id);
        if (code === 0) {
          this.$message.success(message);
          this.handleQuery(true);
        }
      }).catch(() => {});
    }
  }
};

// 批量删除
export const deleteListMixin = {
  methods: {
    // 删除
    handleDeleteList() {
      // 获取表格选中的行
      const ids = this.$refs.elTable.selection.map(m => {
        return m.id;
      });
      if (!ids || ids.length <= 0) {
        this.$message.warning('请勾选需要删除的信息');
        return;
      }
      this.$confirm('确定删除吗?', '提示', {
        type: 'warning'
      }).then(async() => {
        const { code, message } = await this.deleteRows(ids);
        if (code === 0) {
          this.$message.success(message);
          this.handleQuery(true);
        }
      }).catch(() => {});
    }
  }
};
// 编辑获取详细信息（请求接口）
export const detailMixin = {
  props: {
    id: { // ID
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      editLoading: false // 是否是编辑加载中
    };
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if (val) {
          this.editLoading = true;
          this.getDetail(val);
        }
      }
    }
  },
  methods: {
    // 赋值
    assign({ code, data }, fn) {
      if (code === 0) {
        this.form = data;
        if (fn) {
          fn();
        }
      }
      setTimeout(() => {
        this.editLoading = false;
      }, 300);
    }
  }
};

// 编辑获取详细信息（不请求接口）
export const detailDataMixin = {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      editLoading: false // 是否是编辑加载中
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        if (Object.keys(val).length) {
          this.editLoading = true;
          this.form = val;
        }
      }
    }
  }
};

// 保存
export const saveMixin = {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSave() {
      this.$emit('update:loading', true);
      this.$refs.form.validate(async valid => {
        const isValid = await valid;
        if (isValid) {
          // 参数偏差组执行方式为一次
          if (this.form.executeMode === 10) {
            const startTimeStamp = new Date(this.form.startTime).getTime();
            const nowTimeStamp = Date.now();
            if (startTimeStamp < (nowTimeStamp + (1 * 60 * 1000))) {
              this.$alert('开始日期至在当前时间之后至少一分钟');
              this.$emit('update:loading', false);
              return;
            }
          }

          // 新增
          if (!this.form.id) {
            delete this.form.id;
          }
          if (store.state.user.userType !== 10 && this.form.sSBaseId !== undefined) {
            this.form.sSBaseId = store.state.user.sSBaseId;
          }
          const { code, message } = await this.handleSubmit();
          if (code === 0) {
            this.$message.success(message);
            this.$emit('close');
          }
          this.$emit('update:loading', false);
        } else {
          this.$emit('update:loading', false);
          return false;
        }
      });
    }
  }
};

// 序号
export const indexMixin = {
  methods: {
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + (index + 1);
    }
  }
};